module.exports = __webpack_public_path__ + "static/blog_top-a6cea51a00ae6a4c5f9d0859551e6da5.svg";